import React, { useEffect, useState } from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import StickyBox from "react-sticky-box";
import { Helmet } from "react-helmet";
import { DateUtils } from "react-day-picker";

import pageLayout from "HOC/pageLayout";
import PagesModule from "modules/pages";
import EventsModule from "modules/events";
import PageTitle from "components/PageTitle";
import Calendar from "components/Calendar";
import EventCard from "components/EventCard";
import Pagination from "components/Pagination";
import Preloader from "components/Preloader";

import { formatDateByDay, formatDateByMonth } from "helpers/formatDate";

const Events = (props) => {
  const {
    eventsList,
    page,
    total,
    items,
    getCatalog,
    isFetchingCatalog,
    data,
    getData,
    isMobile,
  } = props;

  const [pagePagination, setPage] = useState(page);
  const [daysRange, setDaysRange] = useState({
    from: null,
    to: null,
    enteredTo: null,
  });

  const seo = data?.seo;
  const title = data?.content?.title;

  useEffect(() => {
    getData("events");
  }, []);

  useEffect(() => {
    const formatedDate = formatDateByMonth();

    getCatalog(pagePagination, items, formatedDate, formatedDate);
  }, [pagePagination]);

  useEffect(() => {
    if (pagePagination !== page) {
      setPage(page);
    }
  }, [page]);

  useEffect(() => {
    setPage(1);
  }, []);

  const handlePaginationChange = (page) => {
    setPage(page);
  };

  function isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }

  const handleDayChange = (day) => {
    const selectingFirstDay = isSelectingFirstDay(
      daysRange.from,
      daysRange.to,
      day
    );

    if (selectingFirstDay) {
      setDaysRange({
        from: day,
        to: null,
        enteredTo: null,
      });
    } else {
      setDaysRange({
        from: daysRange.from,
        to: day,
        enteredTo: day,
      });
    }

    if (!selectingFirstDay) {
      getCatalog(
        pagePagination,
        items,
        formatDateByDay(daysRange.from),
        formatDateByDay(day)
      );
    }
  };

  const handleMonthChange = (day) => {
    // console.log(day);
  };

  function handleDayMouseEnter(day) {
    const { from, to } = daysRange;

    if (!isSelectingFirstDay(from, to, day)) {
      setDaysRange({
        ...daysRange,
        enteredTo: day,
      });
    }
  }

  const selectedDays = [
    daysRange.from,
    { from: daysRange.from, to: daysRange.enteredTo },
  ];

  const disabledDays = { before: daysRange.from };

  return (
    <>
      {seo && (
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords}></meta>
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
        </Helmet>
      )}
      <div className="page-body">
        <PageTitle align="center">{title}</PageTitle>

        <div className="content-container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6">
                {isMobile ? (
                  <Calendar
                    currentDaysRange={selectedDays}
                    disabledDays={disabledDays}
                    onDayChange={handleDayChange}
                    onMonthChange={handleMonthChange}
                    handleDayMouseEnter={handleDayMouseEnter}
                  />
                ) : (
                  <StickyBox offsetTop={180} offsetBottom={0}>
                    <Calendar
                      currentDaysRange={selectedDays}
                      disabledDays={disabledDays}
                      onDayChange={handleDayChange}
                      onMonthChange={handleMonthChange}
                      handleDayMouseEnter={handleDayMouseEnter}
                    />
                  </StickyBox>
                )}
              </div>
              <div className="col-12 col-lg-6">
                {isFetchingCatalog ? (
                  <Preloader />
                ) : (
                  <>
                    <div className="events-list">
                      {eventsList && eventsList.length > 0 ? (
                        eventsList.map((item) => {
                          return <EventCard key={item.id} item={item} />;
                        })
                      ) : (
                        <div className="content-block">
                          <p>Sorry, no events for this date yet</p>
                        </div>
                      )}
                    </div>

                    {total > items && (
                      <div className="field-wrap">
                        <Pagination
                          total={total}
                          perPage={items}
                          page={pagePagination}
                          isFetching={isFetchingCatalog}
                          onChange={handlePaginationChange}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default compose(
  pageLayout(),
  connect(
    (state) => {
      return {
        page: state.events.catalog.page,
        total: state.events.catalog.total,
        items: state.events.catalog.items,
        eventsList: state.events.catalog.list,
        isFetchingCatalog: state.events.catalog.isFetching,
        isFetchedCatalog: state.events.catalog.isFetched,
        data: state.pages.events,
        isMobile: state.common.windowWidth < 992,
      };
    },
    {
      getCatalog: EventsModule.getCatalog,
      getData: PagesModule.fetch,
    }
  )
)(Events);
